var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurtainsDrapery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.75C0.638071 0.75 0.75 0.638071 0.75 0.5C0.75 0.361929 0.638071 0.25 0.5 0.25C0.361929 0.25 0.25 0.361929 0.25 0.5C0.25 0.638071 0.361929 0.75 0.5 0.75Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.75C15.6381 0.75 15.75 0.638071 15.75 0.5C15.75 0.361929 15.6381 0.25 15.5 0.25C15.3619 0.25 15.25 0.361929 15.25 0.5C15.25 0.638071 15.3619 0.75 15.5 0.75Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.5H15.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 4.25V15.75H4.5C4.5 15.75 5.25 14 4.25 11",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.25C2.5 10.5 3.1475 9.795 3.75 9.25C5.01562 8.10438 6.5 7 6.5 4",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 9.75H2",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2505 4.25V15.75H11.5005C11.5005 15.75 10.7505 14 11.7505 11",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.25C13.5 10.5 12.8525 9.795 12.25 9.25C10.9844 8.10438 9.5 7 9.5 4",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 9.75H14",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2V3L1.285 2.6075C1.50701 2.49654 1.7518 2.43878 2 2.43878C2.2482 2.43878 2.49299 2.49654 2.715 2.6075L2.785 2.6425C3.00701 2.75346 3.2518 2.81122 3.5 2.81122C3.7482 2.81122 3.99299 2.75346 4.215 2.6425L4.285 2.6075C4.50701 2.49654 4.7518 2.43878 5 2.43878C5.2482 2.43878 5.49299 2.49654 5.715 2.6075L5.785 2.6425C6.00701 2.75346 6.2518 2.81122 6.5 2.81122C6.7482 2.81122 6.99299 2.75346 7.215 2.6425L7.285 2.6075C7.50701 2.49654 7.7518 2.43878 8 2.43878C8.2482 2.43878 8.49299 2.49654 8.715 2.6075L8.83687 2.67C9.04458 2.77401 9.27246 2.83147 9.50465 2.83838C9.73683 2.84528 9.96773 2.80147 10.1812 2.71L10.5681 2.54375C10.7818 2.45231 11.0128 2.40851 11.245 2.41542C11.4773 2.42233 11.7053 2.47977 11.9131 2.58375L12.035 2.64625C12.257 2.75721 12.5018 2.81497 12.75 2.81497C12.9982 2.81497 13.243 2.75721 13.465 2.64625V2.64625C13.7055 2.52593 13.9725 2.46824 14.2413 2.4785C14.51 2.48877 14.7719 2.56668 15.0025 2.705L15.5 3V2",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurtainsDrapery);
export default __webpack_public_path__ + "static/media/curtains-drapery.8dfe2c6f.svg";
export { ForwardRef as ReactComponent };